import Task from "../../../../lib/html5-software-library/src/ranj/util/executor/Task";
import VideoPlayerDispenserHelper from "./VideoPlayerDispenserHelper";

export default class InitVideoPlayerTask extends Task {

    constructor() {
        super();
        
        this.execute = (callback, progressCallback) => {
            // initialize videos dispenser as it needs to be initialized as soon as possible
            // (specially before videos are preloaded)
            VideoPlayerDispenserHelper.initialize().finally(() => {
                //Task complete:
                callback(this);
            });
        }

    }
}